import React, { useEffect, useState } from "react";
import "./footer.css";
import "./footer.scss";
import { Link } from "react-router-dom";
import {
  AiFillFacebook,
  AiOutlineInstagram,
  AiFillYoutube,
} from "react-icons/ai";
import {
  FaTwitter,
  FaLinkedinIn,
  FaTiktok,
  FaWhatsapp,
} from "react-icons/fa";
import { MdOutlineTravelExplore } from "react-icons/md";
import logo from "../../assets/logo.png";

import Aos from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetch("https://admin.mythsegypttours.com/api/settings")
      .then((res) => res.json())
      .then((data) => setSettings(data));
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="footer section">
      <div className="footerContainer container grid">
        {/* Logo & About */}
        <div className="footerLeft">
          <div className="logo">
            <Link to="/" className="logo flex">
              <img src={logo} alt="MYTHS EGYPT TOURS" />
            </Link>
            <span>MYTHS EGYPT TOURS</span>
          </div>

          <p>
            Experience the Myths of Ancient Egypt — where every tour whispers a story
          </p>

          {/* Social Icons */}
          <div className="footerSocials">
            {settings.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer">
                <AiFillFacebook />
              </a>
            )}
            {settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer">
                <AiOutlineInstagram />
              </a>
            )}
            {settings.x && (
              <a href={settings.x} target="_blank" rel="noreferrer">
                <FaTwitter />
              </a>
            )}
            {settings.linkedin && (
              <a href={settings.linkedin} target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
            )}
            {settings.tiktok && (
              <a href={settings.tiktok} target="_blank" rel="noreferrer">
                <FaTiktok />
              </a>
            )}
            {settings.youtube && (
              <a href={settings.youtube} target="_blank" rel="noreferrer">
                <AiFillYoutube />
              </a>
            )}
            {settings.whatsapp && (
              <a
                href={`https://wa.me/${settings.whatsapp.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp />
              </a>
            )}
          </div>
        </div>

        {/* Useful Links */}
        <div className="footerLinks">
          <h3>Useful Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/tours">Tours</a></li>
            <li><a href="/packages">Packages</a></li>
            <li><a href="/about-us">About us</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Day Tours */}
        <div className="footerLinks">
          <h3>Day Tours</h3>
          <ul>
            <li><a href="#">Cairo Day Tours</a></li>
            <li><a href="#">Luxor Day Tours</a></li>
            <li><a href="#">Hurghada Day Tours</a></li>
            <li><a href="#">Cookie Policy</a></li>
          </ul>
        </div>

        {/* Contact & Payments */}
        <div className="footerRight">
          <h3>Get In Touch</h3>
          <p><i className="fas fa-envelope"></i> {settings.email}</p>
          <p><i className="fas fa-phone"></i> {settings.phone}</p>

          <h4>Payment Method</h4>
          <div className="paymentIcons">
            <img src="https://img.icons8.com/color/48/visa.png" alt="Visa" />
            <img src="https://img.icons8.com/color/48/mastercard-logo.png" alt="MasterCard" />
            <img src="https://img.icons8.com/color/48/amex.png" alt="Amex" />
            <img src="https://img.icons8.com/color/48/paypal.png" alt="Paypal" />
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <p>
          {settings.footer_text
            ? settings.footer_text
            : "Copyright © 2025 Myths All Right Reserved"}
        </p>
      </div>
    </section>
  );
};

export default Footer;
